import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';

const Wrap = styled.a`
	color: ${props => props.theme.c2};
	transition: all 0.4s ease-in;
	text-decoration: none;
	border-bottom: 3px solid ${props => props.theme.cg2};
	box-shadow: inset 0 -1rem 0 ${props => props.theme.cg2};
	transition: 0.4s all ease-out;

	${rmq('ml')} {
		font-size: 1.3rem !important;
	}

	&:hover {
		box-shadow: inset 0 -5.5rem 0 ${props => props.theme.ct};
		border-bottom: 3px solid ${props => props.theme.ct};
	}
`;

export default props => <Wrap {...props}>{props.children}</Wrap>;
